import React from 'react'
import PropTypes from 'prop-types'
import TeethView from './TeethView/TeethView'

import { dataAppDatabase, locale, patientsDatabase } from '../../../index'
import { calculateAge, patientOlderThenAge } from '../../../resources/utilities'
import Patient from './Patient/Patient'
import Allergies from './Allergies/Allergies'
import Loading from '../../common/Loading/Loading'
import AgeGrid from './AgeGrid/AgeGrid'
import BiggerScreenMessage from '../../common/BiggerScreenMessage/BiggerScreenMessage'

class Home extends React.Component {
  constructor (props) {
    super(props)
    this.getPatient = this.getPatient.bind(this)
    this.setPatient = this.setPatient.bind(this)
    this.setPatientAges = this.setPatientAges.bind(this)
    this.setAges = this.setAges.bind(this)
    this.state = {
      alert: 'hidden',
      patient: null,
      patientKey: null,
      currentPatientAges: null
    }
  }

  getPatient (patientNumber) {
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale)
    let patient = null
    let patientKey = null
    patientRef.on('value', snapshot => {
      snapshot.forEach((childSnap) => {
        if (childSnap.val().patientNumber.toString() === patientNumber) {
          patient = childSnap.val()
          patientKey = childSnap.key
        }
      })
      if (patient !== null) {
        this.setPatient(patient, patientKey)
        this.props.setPatientId(patient.patientNumber)
      }
    })
  }

  setPatient (patient, patientKey) {
    this.setPatientAges(patient)
    this.setState({
      patient: patient,
      patientKey: patientKey
    })
  }

  handleAllergySubmit (allergy) {
    // window.myLogger.info(JSON.stringify({
    //   message: 'Allergy Submitted',
    //   allergy: allergy,
    //   patientKey: this.props.patientKey
    // }))
    const consultationsRef = patientsDatabase.child(this.state.patientKey).child('data').child('allergies2')
    consultationsRef.push(allergy)
  }

  handleAllergyChange (key, allergy) {
    // window.myLogger.info(JSON.stringify({
    //   message: 'Allergy Changed',
    //   allergyKey: key,
    //   allergy: allergy,
    //   patientKey: this.props.patientKey
    // }))
    const consultationsRef = patientsDatabase.child(this.state.patientKey).child('data').child('allergies2').child(key)
    consultationsRef.set(allergy)
  }

  componentWillMount () {
    this.getPatient(this.props.match.params.patientId)
  }

  setPatientAges (patient) {
    const currentAges = []
    this.props.ages.map(function (value) {
      if (patientOlderThenAge(patient.birthDate, value.ageInterval.start)) {
        currentAges.push(value)
      }
      return null
    })
    this.setAges(currentAges)
  }

  setAges (ages) {
    const agesState = []
    ages.map(function (value) {
      agesState.push(calculateAge(value.ageInterval))
      return null
    })
    this.setState({currentPatientAges: agesState})
    this.props.setPatientAges(agesState)
  }

  getTeethStatus () {
    if (this.state.patient.data) {
      return this.state.patient.data.teethStatus || {}
    } else {
      return {}
    }
  }

  render () {
    return <div className='container'>
      {!this.state.patient || !this.state.currentPatientAges ? <Loading /> : <div>
        <div className='col-sm-12 col-md-4 left-column'>
          <Patient patient={this.state.patient} patientKey={this.state.patientKey} />
          <Allergies
            config={this.props.configuration['allergyInsertion']}
            doctorName={'Ricardo'}
            handleAllergyChange={this.handleAllergyChange.bind(this)}
            handleAllergySubmit={this.handleAllergySubmit.bind(this)}
            patientBirthDate={this.state.patient.birthDate}
            allergies={this.state.patient.data ? this.state.patient.data.allergies2 : null} />
        </div>
        <div className='col-sm-12 col-md-8'>
          <div className='row'>
            <AgeGrid ages={this.state.currentPatientAges} patientId={this.state.patient.patientNumber} />
          </div>
        </div>
        <BiggerScreenMessage />
        <div className='col-sm-12 col-md-8 big-screen-only'>
          <TeethView
            teethStatus={this.getTeethStatus()}
            patientKey={this.state.patientKey}
            currentAge={(this.state.currentPatientAges[this.state.currentPatientAges.length - 1].start).toString()} />
        </div>
      </div>
      }
    </div>
  }
}

Home.propTypes = {
  configuration: PropTypes.object.isRequired,
  setPatientAges: PropTypes.func.isRequired,
  setPatientId: PropTypes.func.isRequired,
  ages: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default Home



// WEBPACK FOOTER //
// ./src/components/general/Home/Home.js